export const invoiceStatusPaid = 'paid';
export const activeStatus = 'active';
export const cancelStatus = 'cancelled';
export const invoiceStatusRefunded = 'refunded';
export const invoiceStatusCancelled = 'cancelled';

export const serviceTimeOptions = [
    {
        id: 10,
        service: '10 minutes',
    },
    {
        id: 15,
        service: '15 minutes',
    },
    {
        id: 20,
        service: '20 minutes',
    },
    {
        id: 30,
        service: '30 minutes',
    },
    {
        id: 45,
        service: '45 minutes',
    },
    {
        id: 60,
        service: '1 hour',
    },
];
export const genderOptions = [
    {
        id: 'male',
        value: 'Male',
    },
    {
        id: 'female',
        value: 'Female',
    },
    {
        id: 'other',
        value: 'Other',
    },
];

export const HomePageIds = {
    whyBeSeen: 'home-page-why-beSeen',
    howItWorks: 'home-page-how-it-works',
    pricing: 'home-page-pricing',
    faqs: 'home-page-faqs',
};

export const timeSlots = Array.from({ length: 24 }, (_, i) => ({
    id: i + 1,
    time: `${i.toString().padStart(2, '0')}:00`,
  }));
  